<script>
  import options from './ProductTable.options'
  export default options
</script>

<template>

<article class="nlx-product-table">

    <section class="nlx-product-table__products-container">

      <template v-if="spinnerVisible">
        <div class="nlx-loading-spinner-overlay">
          <div class="nlx-loading-spinner"></div>
        </div>
      </template>


      <TableComponentGeneric v-model:tableData="productTableData"/>
      <template v-if="noProductsToShow">
        <p class="nlx-product-table__no-products-msg">{{getLabel('noProductsToShow')}}</p>
      </template>
    </section>

    <template v-if="moreResultsAvailable">
      <div class="nlx-product-table__load-more-container">
        <button @click="loadMoreResults" class="nlx-button">{{getLabel('load_more')}}<strong>({{takeValue}})</strong></button>
      </div>
    </template>

  </article>
</template>
